// src/pages/LoginPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Bank from "../components/Bank";


const BankPage = () => {
  return (
    <>
      <Header />
      <Bank />
      <Footer />
    </>
  );
};

export default BankPage;
